import React from 'react';
import { Link } from 'react-router-dom';
//import './BlogList.css'; // Optional: Add custom CSS if needed

const blogPosts = [
  { id: 1, title: 'This Python code simulates the behavior of an ADC' },
  { id: 2, title: 'Basic Elements of a Digital Communication System' },
  { id: 3, title: 'Animation of a simple pendulum in Python' },
  { id: 4, title: 'eUICC vs. Multi-IMSI' },
  { id: 5, title: 'Python script to plot the radiation pattern of a half-wave dipole antenna' },
  { id: 6, title: 'The code simulates and visualizes the 3D radiation pattern of a dipole antenna' },
  { id: 7, title: 'Simulating PID loop with Python' },
  { id: 8, title: 'Additive White Gaussian Noise (AWGN)' },
  { id: 9, title: 'Understanding AT+CPSMS Power Saving Mode Setting' },
  { id: 10, title: 'The Hidden Complexity of 4G LTE' },
  { id: 11, title: 'Understanding OFDM Modulation in LTE: The Backbone of High-Speed Mobile Data' },
];

const BlogList = () => {
  return (
    <div className="container py-4">
      <h1 className="text-center mb-4">Blog Posts</h1>
      <div className="row">
        {blogPosts.map((post) => (
          <div className="col-md-4 mb-3" key={post.id}>
            <div className="card h-100 shadow-sm">
              <div className="card-body">
                <h5 className="card-title text-primary">{post.title}</h5>
                <Link to={`${post.id}`} className="btn btn-outline-primary btn-sm">
                  Read More
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogList;
